// =============================================================================
// ranking.ts — Contrato do ranking de pontuação (issue #88) entre o endpoint
// HTTP (/api/ranking) e a tela de ranking do cliente. A pontuação em si nasce
// na simulação (pontos por abate + tempo vivo) e é persistida no Postgres.
// =============================================================================

// Placar da campanha (a apuração de 20min) e o placar EXCLUSIVO do modo
// infinito (#85) vivem separados: sobreviver ao caos vitalício é outra régua.
// As eleições com seed (#101/#97) entram na mesma tabela com mode próprio +
// a chave do período ('2026-07-05' na diária, '2026-W27' na semanal).
export type RankingMode = 'campanha' | 'infinito' | 'diaria' | 'semanal';

export function isRankingMode(v: unknown): v is RankingMode {
  return v === 'campanha' || v === 'infinito' || v === 'diaria' || v === 'semanal';
}

// Uma linha do ranking: a MELHOR partida de cada eleitor (dedup por conta
// Google quando logado; por nome de urna quando anônimo).
export interface RankingRow {
  name: string;
  charId: string;
  score: number;
  kills: number;
  timeSurvived: number;   // segundos
  difficulty: string;
  createdAt: string;      // ISO
}

export interface RankingResponse {
  ok: boolean;
  configured: boolean;    // false = servidor sem Postgres (modo dev): sem ranking
  rows: RankingRow[];
}

export const RANKING_LIMIT_DEFAULT = 50;
export const RANKING_LIMIT_MAX = 100;
